import React from 'react';
import InstallmentFilter from './InstallmentFilter';
import InstallmentTotal from './InstallmentTotal';
import InstallmentTable from './InstallmentTable';
import { Row, Col, Card, Spin } from 'antd';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function BusinessInstallmentReport() {
    const reports = useReportsStore();
    const loading = reports.installment.loading;


    return (
        <Spin spinning={loading}>
            <Card>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <InstallmentFilter />
                        <InstallmentTotal />
                        <InstallmentTable />
                    </Col>
                </Row>
            </Card>
        </Spin>
    );
}

